import { Schema } from "effect";
import { HttpApiEndpoint, HttpApiGroup } from "effect/unstable/httpapi";
import { STATION_HTTP_PREFIX, StationHttpState, StationUpdatePayload, StationUpdated, StationRevision } from "./http.ts";
import { ImmutableTreeExecutionErrorCode, ImmutableTreeExecutionResourceFailure } from "../errors/source.ts";

const params = /* @__PURE__ */ (() => Schema.Struct({ stationId: Schema.String }))();
const errors = /* @__PURE__ */ (() => [
  ...[400, 404, 405].map(status => Schema.Struct({ error: Schema.String }).annotate({ httpApiStatus: status })),
  Schema.Struct({ error: Schema.String, currentUpdatedAt: Schema.NullOr(StationRevision) }).annotate({ httpApiStatus: 409 }),
  ...[400, 403, 404, 409, 500].map(status => Schema.Struct({ error: Schema.String,
    code: Schema.optionalKey(ImmutableTreeExecutionErrorCode),
    treeId: Schema.optionalKey(Schema.String), workspaceId: Schema.optionalKey(Schema.String),
    resource: Schema.optionalKey(ImmutableTreeExecutionResourceFailure)
  }).annotate({ httpApiStatus: status }))
])();
export const StationApi = HttpApiGroup.make("station").add(
  HttpApiEndpoint.get("read", `${STATION_HTTP_PREFIX}/:stationId`, { params, success: StationHttpState, error: errors }),
  HttpApiEndpoint.put("update", `${STATION_HTTP_PREFIX}/:stationId`, { params, payload: StationUpdatePayload, success: StationUpdated, error: errors })
);
